import * as D from '../../deps';
import * as PodcastConstants from '../constants';

import * as PodcastWorkers from './workers';

export default [
  {
    actionType: PodcastConstants.ActionTypes.REQUEST_PODCAST_GET_DETAILS,
    handler: PodcastWorkers.getDetails,
    concur: 'takeEvery',
  },
  {
    actionType: PodcastConstants.ActionTypes.REQUEST_ALL_THUMBED_EPISODES,
    handler: PodcastWorkers.getAllThumbedEpisodesByPodcastProgram,
    concur: 'takeEvery',
  },
  {
    actionType: PodcastConstants.ActionTypes.REQUEST_ALL_EPISODES_BY_PROGRAM,
    handler: PodcastWorkers.getAllEpisodesByPodcastProgram,
    concur: 'takeEvery',
  },
  {
    actionType: PodcastConstants.ActionTypes.REQUEST_ANNOTATE_AESOP_OBJECTS,
    handler: PodcastWorkers.annotateAesopObjects,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.FEEDBACK_ADDED,
    handler: PodcastWorkers.onItemFeedbackAdded,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Integrations.ActionTypes.FEEDBACK_REMOVED,
    handler: PodcastWorkers.onItemFeedbackRemoved,
    concur: 'takeLatest',
  },
  {
    actionType: PodcastConstants.ActionTypes.AESOP_REMOVE_EPISODES_FEEDBACK,
    handler: PodcastWorkers.removeEpisodesFeedback,
    concur: 'takeEvery',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PLAYING,
    handler: PodcastWorkers.onAudioPlayerStarted,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.PAUSED,
    handler: PodcastWorkers.onAudioPlayerPaused,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.ENDED,
    handler: PodcastWorkers.onAudioPlayerEnded,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.AudioPlayer.AudioPlayerActions.SCRUB_AUDIO,
    handler: PodcastWorkers.onAudioPlayerScrubbed,
    concur: 'takeLatest',
  },
  {
    actionType: D.Constants.Api.ApiActions.AESOP_GET_DETAILS_SUCCESS,
    handler: PodcastWorkers.onAesopGetDetailsSuccess,
    concur: 'takeEvery',
  },
  {
    actionType: [
      D.Constants.Api.ApiActions.COLLECTIONS_GET_SORTED_BY_TYPES_SUCCESS,
      D.Constants.Api.ApiActions.COLLECTIONS_GET_SORTED_BY_TYPES_V6_SUCCESS,
      D.Constants.Api.ApiActions.SOD_SEARCH_SUCCESS,
    ],
    handler: PodcastWorkers.requestAnnotationsFromAction,
    concur: 'takeEvery',
  },
];
